'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAway = undefined;

var _isAgentState = require('./isAgentState');

var _AgentStates = require('../../constants/AgentStates');

var isAway = exports.isAway = (0, _isAgentState.isAgentState)(_AgentStates.AWAY);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/operators/agent-state/isAway.js
// module id = 1012
// module chunks = 2 3